// Routes of the e-mail link login flow. Kept out of router/index.ts so the Clerk
// plugin and the auth composable can import them without pulling in the router.
export const LOGIN_VERIFY_PATH = "/login/verify"
export const LOGIN_DONE_PATH = "/login/done"
export const LOGIN_VERIFY_ROUTE = "login-verify"
export const LOGIN_DONE_ROUTE = "login-done"
// Routes on which the app must not sync the Django user or redirect into the app.
export const EMAIL_LINK_ROUTES = [LOGIN_VERIFY_ROUTE, LOGIN_DONE_ROUTE]
